import { render, staticRenderFns } from "./BlockPakketSelectie.vue?vue&type=template&id=2f28c5c9&"
import script from "./BlockPakketSelectie.vue?vue&type=script&lang=js&"
export * from "./BlockPakketSelectie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports